import { render, staticRenderFns } from "./AdminHelpLayout.vue?vue&type=template&id=23fa3c4d&scoped=true"
import script from "./AdminHelpLayout.vue?vue&type=script&lang=js"
export * from "./AdminHelpLayout.vue?vue&type=script&lang=js"
import style0 from "./AdminHelpLayout.vue?vue&type=style&index=0&id=23fa3c4d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fa3c4d",
  null
  
)

export default component.exports